import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pushGtmPageview } from "@/lib/gtm";

// Seeded with the URL GTM's own snippet already tracked on hard load; guards StrictMode double-invoke
let lastTrackedPath = window.location.pathname + window.location.search;

const trackPathChange = (path) => {
  if (path === lastTrackedPath) return;
  lastTrackedPath = path;
  pushGtmPageview(path);
};

const GtmPageview = () => {
  const { pathname, search } = useLocation();
  const currentPath = pathname + search;

  useEffect(() => {
    trackPathChange(currentPath);
  }, [currentPath]);

  return null;
};

export default GtmPageview;
